<template>
    <div class="page">
        <div class="topBox">
            <!-- <div class="topTitle">CONTACT</div>
            <div class="topTitle2">联系我们</div>
            <div class="line"></div> -->
        </div>

        <pageBreadcrumb :option="nav_option" />

        <!-- <div class="swtichBox">
            <div class="wrap">
                <div class="switchFlexBox">
                    <div class="switchBtn" @click="switchPageType(0)" :class="{ active: !!(pageType == 0) }">联系我们</div>
                    <div class="lineText">|</div>
                    <div class="switchBtn" @click="switchPageType(1)" :class="{ active: !!(pageType == 1) }">加入我们</div>
                </div>
            </div>
        </div> -->

        <div class="centerFlexBox">
            <div class="wrap">
                <div class="flexBox">
                    <div class="flexItem">
                        <el-image class="erweima" :src="configInfo.shareImg" fit="cover"></el-image>
                        <div class="title2">{{ $t('欢迎关注海伦鼓尚在线平台') }}</div>
                    </div>
                    <div class="flexItem">
                        <el-image class="localIcon" :src="require('../../assets/img/contact/local.png')" fit="cover"></el-image>
                        <div class="title">{{ $t('地址') }}</div>
                        <div class="title2">{{ lang == 'en' ? configInfo.enComAddress : configInfo.comAddress }}</div>
                    </div>
                    <div class="flexItem">
                        <el-image class="emailIcon" :src="require('../../assets/img/contact/email.png')" fit="cover"></el-image>
                        <div class="title">{{ $t('邮箱') }}</div>
                        <div class="title2">{{ configInfo.comEmail }}</div>
                    </div>
                    <div class="flexItem">
                        <el-image class="telIcon" :src="require('../../assets/img/contact/tel.png')" fit="cover"></el-image>
                        <div class="title">{{ $t('电话') }}</div>
                        <div class="title2">{{ configInfo.comPhone }}</div>
                    </div>
                </div>
                <!-- <div class="flexBox2">
                    <div class="flexItem">
                        <el-image class="erweima" :src="configInfo.accountImg" fit="cover"></el-image>
                        <div class="title2">欢迎关注海伦鼓尚公众号</div>
                    </div>
                    <div class="flexItem">
                        <el-image class="erweima" :src="configInfo.appletImg" fit="cover"></el-image>
                        <div class="title2">欢迎关注海伦鼓尚视频号</div>
                    </div>
                </div> -->
                <div class="fill104"></div>
            </div>
        </div>

        <!-- <div class="messageBox">
            <div class="wrap">
                <div class="messageTitle">MESSAGE</div>
                <div class="messageTitle2">留言给我们</div>
                <div class="msgInputFlexBox">
                    <div class="msgInputBox">
                        <input type="text" placeholder="您的姓名" v-model="name" class="msgInput" />
                    </div>
                    <div class="msgInputBox">
                        <input type="text" placeholder="您的电话" v-model="tel" class="msgInput" />
                    </div>
                </div>
                <div class="msgTextAreaBox">
                    <textarea class="msgTextArea" placeholder="留言内容" v-model="content" cols="30" rows="2"></textarea>
                </div>
                <div class="msgSubBtn btn-ripple" @click="subBtn">私人订制</div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'

export default {
    name: 'contact',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            nav_option: [
                { title: '首页', path: '/' },
                { title: '联系我们', path: '' },
            ],
            pageType: 0, // 页面状态：0.企业新闻，1.行业资讯
            name: '',
            tel: '',
            content: '',
        }
    },
    computed: {
        ...mapState(['configInfo']),
    },
    watch: {},
    created() {
        this.nav_option = [
            { title: this.$t('首页'), path: '/' },
            { title: this.$t('联系我们'), path: '' },
        ]
    },
    mounted() {
        window.removeEventListener('scroll', this.onScroll)
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        async subBtn() {
            function checkPhone(tel) {
                if (!tel) {
                    return false
                }
                let regu = /^1[3-9][0-9]{9}$/

                if (regu.test(tel)) {
                    return true
                } else {
                    return false
                }
            }
            if (!this.name) {
                alertErr(this.$t('请输入您的姓名'))
                return
            }
            if (!checkPhone(this.tel)) {
                alertErr(this.$t('请输入有效的手机号'))
                return
            }
            if (!this.content) {
                alertErr(this.$t('请输入留言内容'))
                return
            }
            let obj = {
                name: this.name,
                phone: this.tel,
                content: this.content,
            }
            this.$load.open()
            let res = await this.feedbackAddAjax(obj)
            await this.$load.close()
            if (res && res.code == 200) {
                alertSucc(this.$t('留言成功'))
                this.name = ''
                this.tel = ''
                this.content = ''
            } else {
                alertErr(this.$t('留言失败，请重试！'))
            }
        },
        feedbackAddAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'feedback_add',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        onScroll() {
            let scrollTop = 0
            if (document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop
            } else if (document.body) {
                scrollTop = document.body.scrollTop
            }

            if (scrollTop < 1322) {
                this.pageType == 0
            } else {
                this.pageType == 1
            }
        },
        goNewsDetail() {
            this.$router.push('/newsDetail')
        },
        switchPageType(type) {
            if (type == 0) {
                window.scrollTo({
                    top: 413,
                    left: 0,
                    behavior: 'smooth', // 可选，平滑滚动效果
                })
            } else if (type == 1) {
                window.scrollTo({
                    top: 1322,
                    left: 0,
                    behavior: 'smooth', // 可选，平滑滚动效果
                })
            }
        },
        changePage() {},
        goArtistDetail() {
            this.$router.push('/artistDetail')
        },
    },
}
</script>

<style scoped lang="less">
.topBox {
    width: 100%;
    height: 400px;
    background: url('../../assets/img/contact/topBg.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    margin-bottom: 50px;

    .topTitle {
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        font-family: 'myTextStyle';
        margin-bottom: 23px;
    }

    .topTitle2 {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        margin-bottom: 110px;
    }

    .line {
        width: 155px;
        height: 3px;
        background: #ffffff;
        margin: 0 auto;
    }
}

.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;
}

.swtichBox {
    width: 100%;
    margin-top: 24px;
    margin-bottom: 142px;

    .switchFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .switchBtn {
            font-weight: 400;
            font-size: 20px;
            color: #000000;
            line-height: 34px;
            cursor: pointer;

            &:hover {
                font-weight: bold;
                color: #ff4d00;
            }

            &.active {
                font-weight: bold;
                color: #ff4d00;
            }
        }

        .lineText {
            font-weight: 400;
            font-size: 20px;
            color: #000000;
            line-height: 34px;
            margin: 0 30px;
        }
    }
}

.centerFlexBox {
    width: 100%;
    margin-top: 80px;

    .flexBox {
        width: 100%;
        height: 263px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 36px;

        .flexItem {
            width: 500px;
            height: 263px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid rgba(112, 112, 112, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .localIcon {
                width: 53.71px;
                height: 65.22px;
                margin-bottom: 26px;
            }

            .emailIcon {
                width: 63px;
                height: 46px;
                margin-bottom: 36px;
            }

            .telIcon {
                width: 61px;
                height: 58px;
                margin-bottom: 26px;
            }

            .title {
                width: 100%;
                text-align: center;
                font-weight: 400;
                font-size: 25px;
                color: #000000;
                line-height: 25px;
                margin-bottom: 26px;
            }

            .title2 {
                width: 100%;
                text-align: center;
                font-size: 18px;
                color: #555555;
                line-height: 18px;
            }
        }

        .flexItem {
            width: 500px;
            height: 263px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid rgba(112, 112, 112, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-right: 50px;

            .erweima {
                width: 140px;
                height: 140px;
                margin-bottom: 0px;
                position: relative;
                top: -14px;
            }

            .title2 {
                width: 100%;
                text-align: center;
                font-size: 18px;
                color: #555555;
                line-height: 18px;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .flexBox2 {
        width: 100%;
        height: 263px;
        display: flex;
        align-items: center;
        justify-content: center;

        .flexItem {
            width: 500px;
            height: 263px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid rgba(112, 112, 112, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-right: 50px;

            .erweima {
                width: 100px;
                height: 100px;
                margin-bottom: 42px;
            }

            .title2 {
                width: 100%;
                text-align: center;
                font-size: 18px;
                color: #555555;
                line-height: 18px;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.messageBox {
    width: 100%;
    height: 650px;
    background: url('../../assets/img/index/messageBg.png') no-repeat;
    background-size: 100% 100%;

    .messageTitle {
        font-weight: 400;
        font-size: 65px;
        color: #ff4d00;
        line-height: 75px;
        width: 100%;
        text-align: center;
        margin-top: 130px;
        font-family: myTextStyle;
    }

    .messageTitle2 {
        font-weight: bold;
        font-size: 50px;
        line-height: 50px;
        color: #ffffff;
        width: 100%;
        text-align: center;
        margin-bottom: 87px;
    }

    .msgInputFlexBox {
        width: 64vw;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;

        .msgInputBox {
            width: 45%;
            height: 50px;
            background: #ffffff;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #707070;
            margin-right: 10%;
            padding: 0 18px;
            overflow: hidden;

            &:last-child {
                margin-right: 0;
            }

            .msgInput {
                width: 100%;
                font-size: 18px;
                line-height: 50px;
                color: #444444;
                font-family: Source Han Sans CN, Source Han Sans CN;
            }
        }
    }

    .msgTextAreaBox {
        width: 64vw;
        margin: 0 auto;
        height: 100px;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #707070;
        overflow: hidden;
        padding: 18px;
        margin-top: 25px;

        .msgTextArea {
            width: 100%;
            height: 100%;
            font-size: 18px;
            line-height: 25px;
            color: #444444;
            font-family: Source Han Sans CN, Source Han Sans CN;
            border: none;
            outline: none; /*边线不显示*/
            resize: none; /*禁止拉伸*/
            appearance: none;
        }
    }

    .msgSubBtn {
        width: 300px;
        height: 50px;
        background: #ff4d00;
        border-radius: 0px 0px 0px 0px;
        margin: 25px auto 0 auto;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        line-height: 20px;
        color: #ffffff;
    }
}

.fill104 {
    width: 100%;
    height: 104px;
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/contact.less"></style>
